import gql from 'graphql-tag'

export const LIST_CATEGORIES = gql`
  query ListCategoriesQuery($limit: Int!, $offset: Int!, $orderBy: String!, $isDelete: Float!){
    listCategories(orderBy: $orderBy){
      results(limit: $limit, offset: $offset){
        id
        name
        profiles(isDelete: $isDelete){
          id
        }
      }      
      totalCount
    }
  } 
`

export const LIST_QUERY_CATEGORIES = gql`
  query ListCategoriesQuery($limit: Int!, $offset: Int!, $orderBy: String!, $name: String!){
    listCategories(name_Icontains:$name, orderBy: $orderBy){
      results(limit: $limit, offset: $offset){
        id
        name
      }      
      totalCount
    }
  } 
`

export const LIST_CATEGORY_CONTACTS_WITH_WORK = gql`
  query ListCategoryContactsQuery($limit: Int!, $offset: Int!, $categoryId: Float!, $orderBy: String!, $profileIsDelete: Float!){ 
    listCategoryProfile(categoryId: $categoryId, orderBy: $orderBy, profileIsDelete: $profileIsDelete){
      results(limit: $limit, offset: $offset){
        profile{
          id
          number
          name
          lastName
          avatarImg
          gender
          facebookUrl
          instagramUrl
          lastSmsBody
          hasUnread
          pendingStatus
          profileWorkHistory{
            id
            organization{
              id
              name
            }
            title{
              id
              name
            } 
          }
        }
      }
      totalCount
    }
  }
`

export const LIST_EDIT_CATEGORY_CONTACTS = gql`
  query ListCategoryContactsQuery($limit: Int!, $offset: Int!, $categoryId: Float!, $orderBy: String!, $profileIsDelete: Float!){ 
    listCategoryProfile(categoryId: $categoryId, orderBy: $orderBy, profileIsDelete: $profileIsDelete){
      results(limit: $limit, offset: $offset){
        profile{
          id
          number
          name
          lastName
          avatarImg
          gender
          facebookUrl
          instagramUrl
          birthyear
          description
          categorySet{
            id
            name
          }
          groupSet{
            id
            name
          }
          bdayTags (name: "birthday"){
            id
            intValue
            strValue
            name
          }
          profileWorkHistory{
            id
            organization{
              id
              name
            }
            title{
              id
              name
            }                     
          }
        }
      }
      totalCount
    }
  }
`
